export const URL_DAILY_INCOME = '/news/161',
    URL_HOME = '/',
    URL_NATIONAL_CASHBACK = '/news/150',
    URL_NEWS_WINTER_SUPPORT = '/news/139',
    URL_TOUCH_WIN_OFFER = '/touch_win_offer',
    URL_KIDS_CARD_OFFER = '/kids_card_offer2',
    URL_CASHBACK = '/cards/cashback_ua',
    URL_HAPPY_ATB = '/special_offers/ATB_offer',
    URL_SUNNY_TARIFF = '/special_offers/sunny_tariff',
    URL_VYGODA = '/cards/vygoda',
    URL_INSTALLMENT = '/credit/installment_from_statement',
    URL_ENERGY = '/business/energy_all',
    URL_PBP = '/credit/pbp',
    URL_SEARCH = '/search',
    BRANCHES_RAMPA_PARAM = '?rampa',
    URL_BRANCHES = '/branches',
    URL_BRANCHES_RAMPA = `${URL_BRANCHES}${BRANCHES_RAMPA_PARAM}`,
    URL_SERVICES = '/services/abank',
    URL_CONTACTS = '/contacts',
    URL_INVITE_FRIEND = '/services/invite_friend',
    URL_DEPOSITS_FRAME = '/deposits#frame',
    URL_INSURANCE = '/services/insurance',
    URL_SAFE_BOXES = '/services/safe_boxes',
    URL_ACQUIRING = '/business/acquiring',
    URL_BECOME_PARTNER = '/services/become-partner',
    URL_TRANSFERS = '/services/transfers',
    URL_QUICK_CASH = '/credit/quick_cash',
    URL_NEWS = '/news',
    URL_DIIA = '/cards/diia',
    DIIA_ESPORT_PARAM = '?esport',
    DIIA_EBOOK_PARAM = '?ebook',
    DIIA_BOX_SCHOOL_BOY_PARAM = '?boxschoolboy',
    DIIA_NEWS_PAYONEER = '/news/144',
    DIIA_HEALTH_SCREENING_PARAM = '?screening',
    DIIA_CHILD_CARE = '?childcare',
    URL_VETERAN = `${URL_DIIA}${DIIA_ESPORT_PARAM}`,
    URL_BOOK = `${URL_DIIA}${DIIA_EBOOK_PARAM}`,
    URL_BOX_SCHOOL_BOY = `${URL_DIIA}${DIIA_BOX_SCHOOL_BOY_PARAM}`,
    URL_HEALTH_SCREENING = `${URL_DIIA}${DIIA_HEALTH_SCREENING_PARAM}`,
    DIIA_NEWS_CIVIL_CAR_COMPENSATION = '/news/147',
    URL_CHILD_CARE = `${URL_DIIA}${DIIA_CHILD_CARE}`,
    URL_RECEIPT = '/business/gov/e-receipt',
    URL_AI_REQUISITES_PAYMENT = '/news/158',
    URL_DOUBLE_SALARY = '/special_offers/double_salary',
    URL_PROSTOR = '/cards/prostor';
